<!--suppress ALL -->
<template>
  <div>
    <div class="category-filter-item">
      <CatalogCategoryFilterItemLabel
        :name="category.name"
        :value="category.value"
        :selected="isSelected"
        :show-count="showCount"
        :count="category.count"
        @click="handleClick"
      />
    </div>
    <div
      v-if="hasChildren && (isSelected || isSelectedNested)"
      class="category-filter-item__children"
    >
      <CatalogCategoryFilterItem
        v-for="categoryItem in category.children"
        :key="categoryItem.value"
        :category="categoryItem"
        :selected="selected"
        :selected-nested-categories="selectedNestedCategories"
        @on-change-category="onChangeCategory"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FilterCategory } from '~/types/catalog'

type Props = {
  category: FilterCategory
  selected: FilterCategory | null
  selectedNestedCategories: FilterCategory[]
}
type Emits = {
  (e: 'on-change-category', value: FilterCategory): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()


const isSelected = computed(() => {
  return props.selected
    ? props.category.value === props.selected.value
    : props.category.value.length === 0
})

const selectedChild = computed<FilterCategory | undefined>(() => {
  let childSelected

  if (props.selectedNestedCategories.length) {
    childSelected = props.selectedNestedCategories.find((child: FilterCategory) => {
      return child.value === props.category.value
    })
  }
  return childSelected
})

const isSelectedNested = computed(() => {
  return selectedChild.value && props.category
    ? props.selected && props.category.value === selectedChild.value.value
    : false
})

const hasChildren = computed(() => {
  return !!(props.category.children?.length > 0)
})

const showCount = computed(() => {
  return Boolean(props.category.value && props.category.parent)
})

const onChangeCategory = (category: FilterCategory) => {
  emit('on-change-category', category)
}

const handleClick = () => {
  emit('on-change-category', props.category)
}
</script>

<style lang="scss">
.category-filter-item {
  cursor: pointer;

  &__children {
    padding: 0 0 0.4rem 1.6rem;
    line-height: 1.8rem;
  }
}
</style>
